<molecule-action-button
    parentContainer="body"
    [btnClass]="btnClass"
    [hideDropdownChevron]="true"
    [actionButton]="actionButton"
    (selectMenuItem)="onSelectMenuItem($event)"
    (dropdownMenuToggled)="onDropdownMenuToggled()"
></molecule-action-button>
